import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { collection, getDocs, query, where } from "firebase/firestore";
import { analytics, db } from "../services/Firebase";
import logoImage from "../images/logo192.png"
import { useAuth } from "../hooks/AuthContext";
import { useTranslation } from "react-i18next";
import { formatDate, formatTime } from "../utils/FormatDateTime";
import { Button } from "react-bootstrap";
import { logEvent } from "firebase/analytics";
import { canAnalyzeMore } from "../utils/LimitHelper";
import { BadgeInfo, Calendar, LockKeyhole } from "lucide-react";

export default function PredefinedLeagues() {
    const { leagueId } = useParams();
    const [matches, setMatches] = useState([]);
    const [loading, setLoading] = useState(true);
    const { authUser, authLoading } = useAuth()
    const navigate = useNavigate()
    const { t } = useTranslation()
    const location = useLocation();
    const { leagueName, leagueFlag } = location.state || {};


    const today = new Date();
    const startOfDay = new Date(today.getFullYear(), today.getMonth(), today.getDate());
    const endOfDay = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1);

    useEffect(() => {
        const fetchMatches = async () => {

            if (!authUser && !authLoading) {
                console.log("user not authorized")
                setLoading(false);
                return;
            }
            try {
                console.log(`about to fetch for league id = ${leagueId}`)

                const matchesRef = collection(db, `footballSuggestions/${leagueId}/matches/`); // todo query with date
                const q = query(matchesRef, where("date", ">=", startOfDay.toISOString()), where("date", "<", endOfDay.toISOString()));

                const snapshot = await getDocs(q);
                const data = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
                console.log(`fetched for league id = ${leagueId}`)

                setMatches(data);
            } catch (err) {
                console.error("Error fetching matches:", err);
            } finally {
                setLoading(false);
            }
        };

        fetchMatches();
    }, [leagueId]);

    const goToSearchPage = () => {
        navigate("/")
    }

    function onSelectMatch(match, index) {
        if (!canAnalyzeMore(!!authUser)) {
            let alertMessage = t('dailyLimitReached')
            if (authUser !== null) {
                alertMessage = t('todayLimitUsed')
                logEvent(analytics, "match_selected", {
                    list_position: index,
                    is_logged_in: !!authUser
                })
            } else {
                // todo poslati analytic event za limit neulogovanog
            }
            alert(alertMessage);
            return;
        }
        const selectedMatch = {
            id: match.fixtureId,
            teamHomeId: match.homeTeamId,
            teamAwayId: match.awayTeamId,
            teamHomeName: match.homeTeam,
            teamAwayName: match.awayTeam,
            matchDate: match.date
        }

        navigate('/result', { state: selectedMatch });
    }

    const handleProfileClick = () => {
        navigate('/profile')
    }

    const goToLoginPage = () => {
        navigate('/login')
    }

    return (
        <div>
            <div className="header-container">
                <div onClick={() => goToSearchPage()} className='header-left'>
                    <img src={logoImage} alt="Logo" className="logo" />
                    <h3>Sigurica AI</h3>
                </div>
                <div className='header-right'>
                    {authLoading ? (
                        <div className="spinner-border spinner-border-sm-auth me-4" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    ) : authUser ? (
                        <Button onClick={() => handleProfileClick()} className='button-profile'><i className="bi bi-person-circle"></i>{t('memberProfile')}</Button>
                    ) : (
                        <>
                            <Button onClick={() => goToLoginPage()} className='button-login'><i className="bi bi-box-arrow-in-right"></i>{t('loginMember')}</Button>
                        </>
                    )}
                </div>
            </div>

            <div className="predefinedLeaguesBackground">
                <div className="predefined-league-overlay">

                    {loading ? (
                        <div className="spinner-wrapper">
                            <div className="spinner-border spinner-border-sm-custom" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    ) : !authUser ? (
                        <>
                            <div className="predefined-cards-grid">
                                <div className="predefined-card-info" >
                                    <div>
                                        <div className="predefined-icon-background">
                                            <LockKeyhole className="predefined-icon-color" />
                                        </div>
                                        <p className="predefined-card-text">{t('mustBeLogin')}</p>
                                    </div>
                                    <div>
                                        <div className="predefined-icon-background">
                                            <BadgeInfo className="predefined-icon-color" />
                                        </div>
                                        <p className="predefined-card-text">{t('predefinedLeaguesAnalyticsText')}</p>
                                    </div>
                                </div>
                            </div>
                        </>
                    )
                        : matches.length > 0 ? (
                            <>
                                <h2>{t('selectMatch')}</h2>
                                <div>
                                    <img src={leagueFlag} alt={leagueName} className="predefined-flag-league" />
                                    <span className="predefined-league-name">{leagueName}</span>
                                </div>
                                <div className="predefined-matches-grid">
                                    {matches.map((match, index) => (
                                        <div className="predefined-match-card" onClick={() => onSelectMatch(match, index)} key={match.id}>
                                            <div className="predefined-match-info">
                                                <div className="predefined-match-middle">
                                                    <div className="predefined-match-score">
                                                        {formatTime(match.date)}h
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="predefined-club-names">
                                                <span>{match.homeTeam}</span>
                                                <span>{match.awayTeam}</span>
                                            </div>
                                            <div>
                                                <p className='predefined-match-prediction'><span className="prediction-text">{t('predictability')}</span>{match.predictabilityScore}%</p>
                                            </div>
                                            <div>
                                                <div className='predefined-match-date-time'>{formatDate(match.date)}</div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </>
                        ) : (
                            <>
                                <div>
                                    <img src={leagueFlag} alt={leagueName} className="predefined-flag-league" />
                                    <span className="predefined-league-name">{leagueName}</span>
                                </div>

                                <div className="predefined-cards-grid">
                                    <div className="predefined-card-info" >
                                        <div>
                                            <div className="predefined-icon-background">
                                                <Calendar className="predefined-icon-color" />
                                            </div>
                                            <p className="predefined-card-text">{t('noMatchesToday')}</p>
                                        </div>
                                        <div>
                                            <div className="predefined-icon-background">
                                                <BadgeInfo className="predefined-icon-color" />
                                            </div>
                                            <p className="predefined-card-text">{t('predefinedLeaguesAnalyticsText')}</p>
                                        </div>
                                    </div>
                                </div>
                            </>
                        )
                    }

                </div>
            </div>
        </div>
    );
}
